// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopularLocationGrid-GridCollapse-k3Osp {
	position: relative;
}

.PopularLocationGrid-containerTitle-r_4CL {
	color: var(--secondary-oscuro);
	line-height: normal;
	margin: 0;
	padding: 0px 15px 0 6px;
	font-weight: bold;
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	margin-bottom: 15px;
	gap: 10px;
}

.PopularLocationGrid-popularLocationSwiperContainer-Nhk3C {
	position: relative;
}

.PopularLocationGrid-noMargin-eT_Q3 {
	border-radius: 19px;
	padding: 15px;
	margin: 0 auto;
	/* border: 1px solid var(--primary-color) */
}

.PopularLocationGrid-sliderHeadingFlex-NZj06 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 10px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	margin: 0 0 15px;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	font-family: var(--font-family-base);
}

.PopularLocationGrid-highlight-q_UZG {
	color: var(--primary-color);
}

@media screen and (max-width: 767px) {
	.PopularLocationGrid-containerTitle-r_4CL {
		font-size: 22px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Home/PopularLocationGrid/PopularLocationGrid.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;AACnB;;AAEA;CACC,8BAA8B;CAC9B,mBAAmB;CACnB,SAAS;CACT,uBAAuB;CACvB,iBAAiB;CACjB,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,cAAc;CACd,2CAA2C;AAC5C;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;CACT,mBAAe;KAAf,eAAe;CACf,gBAAgB;CAChB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,oCAAoC;AACrC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC;EACC,eAAe;CAChB;AACD","sourcesContent":[".GridCollapse {\n\tposition: relative;\n}\n\n.containerTitle {\n\tcolor: var(--secondary-oscuro);\n\tline-height: normal;\n\tmargin: 0;\n\tpadding: 0px 15px 0 6px;\n\tfont-weight: bold;\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-bottom: 15px;\n\tgap: 10px;\n}\n\n.popularLocationSwiperContainer {\n\tposition: relative;\n}\n\n.noMargin {\n\tborder-radius: 19px;\n\tpadding: 15px;\n\tmargin: 0 auto;\n\t/* border: 1px solid var(--primary-color) */\n}\n\n.sliderHeadingFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n\tflex-wrap: wrap;\n\tmargin: 0 0 15px;\n\tjustify-content: space-between;\n\tfont-family: var(--font-family-base);\n}\n\n.highlight {\n\tcolor: var(--primary-color);\n}\n\n@media screen and (max-width: 767px) {\n\t.containerTitle {\n\t\tfont-size: 22px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"GridCollapse": `PopularLocationGrid-GridCollapse-k3Osp`,
	"containerTitle": `PopularLocationGrid-containerTitle-r_4CL`,
	"popularLocationSwiperContainer": `PopularLocationGrid-popularLocationSwiperContainer-Nhk3C`,
	"noMargin": `PopularLocationGrid-noMargin-eT_Q3`,
	"sliderHeadingFlex": `PopularLocationGrid-sliderHeadingFlex-NZj06`,
	"highlight": `PopularLocationGrid-highlight-q_UZG`
};
module.exports = ___CSS_LOADER_EXPORT___;
